import React, { useState, useEffect } from "react";
import {
  Input,
  Select,
  Col,
  Row,
  Form,
  notification,
  Button,
  Empty,
} from "antd";
import RequestHandler from "util/RequestHandler";
import { PlusOutlined } from "@ant-design/icons";
import "react-phone-input-2/lib/style.css";
const { Option } = Select;
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 12,
    },
  },
};

const tailLayout = {
  wrapperCol: {
    offset: 15,
    span: 5,
  },
};

const InvoiceSubscriptionUpdate = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [productTypes, setProductTypes] = useState({
    data: [],
    loading: true,
  });
  const [products, setProducts] = useState({
    data: [],
    loading: true,
  });
  const [product, setProduct] = useState(props.data.product);
  const [productType, setProductType] = useState(props.data.productType);
  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
    const filtervalue = "'" + props.data.productTypeId + "'";
    RequestHandler.get(`/Invoice/GetProductTypes`, false, {
      rawResponse: true,
    }).then((response) => {
      if (response.status == 200) {
        setProductTypes({
          data: response.data,
          loading: false,
        });
      }
    });

    RequestHandler.post(
      `/Invoice/GetProducts?$filter=productTypeId eq  ${filtervalue}&$orderby=name`,
      {},
      false
    ).then((response) => {
      if (response.value != Empty) {
        setProducts({
          data: response,
          loading: false,
        });
      } else {
        setProducts({
          data: [],
        });
      }
    });
  }, [props.data]);

  const getProducts = (value) => {
    const filtervalue = "'" + value + "'";
    RequestHandler.post(
      `/Invoice/GetProducts?$filter=productTypeId eq  ${filtervalue}&$orderby=name`,
      {},
      false
    ).then((response) => {
      if (response.value != Empty) {
        setProducts({
          data: response,
          loading: false,
        });
      } else {
        setProducts({
          data: [],
        });
      }
    });
  };

  const handleSelectedProductTypes = (value) => {
    setProductType(value);
    form.resetFields(["product"]);
    setProduct("");
    getProducts(value);
  };

  const onFinishFailed = () => {
    setLoading(false);
  };

  const onFinishUpdate = (values) => {
    const productTypeName =
      productTypes.data.find((x) => x.id == values.productType)?.name ??
      productTypes.data.find((x) => x.name == values.productType)?.name;
    const productName =
      products.data.find((x) => x.id == values.product)?.name ??
      products.data.find((x) => x.name == values.product)?.name;
    RequestHandler.put(
      "/InvoiceSubscription",
      {
        id: props.data.id,
        name: values.name,
        product: productName,
        productType: productTypeName,
        subscriberNo: values.subscriberNo,
      },
      true
    ).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      } else {
        setLoading(false);
      }
    });
  };

  const onSuccess = () => {
    form.resetFields();

    if (props.onSuccess) props.onSuccess();
  };

  return (
    <div>
      <>
        <Form
          {...formItemLayout}
          initialValues={{
            remember: true,
          }}
          name="invoiceSubscriptionUpdate"
          form={form}
          onFinish={onFinishUpdate}
          onFinishFailed={onFinishFailed}
        >
          <Row>
            <Col span={2}></Col>
            <Col span={20}>
              <Form.Item
                label="Kurum Tipi :"
                name="productType"
                style={{ marginTop: "4%" }}
                rules={[
                  {
                    required: true,
                    message: "Lütfen Kurum Tipi alanını boş bırakmayın.",
                  },
                ]}
              >
                <Select
                  name="productTypes"
                  style={{ width: "100%", marginBottom: "3%" }}
                  loading={false}
                  onChange={handleSelectedProductTypes}
                >
                  {productTypes.data.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="Kurum :"
                name="product"
                rules={[
                  {
                    required: true,
                    message: "Lütfen Kurum alanını boş bırakmayın.",
                  },
                ]}
              >
                <Select
                  autoClearSearchValue
                  showSearch
                  optionFilterProp="children"
                  name="products"
                  style={{ width: "100%" }}
                  loading={false}
                  value={product}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {products.data.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item label="Abone No" name="subscriberNo">
                <Input
                  type="text"
                  autoComplete="off"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Abone no alanını boş bırakmayın.",
                    },
                  ]}
                  onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
              </Form.Item>
              <Form.Item label="Ad :" name="name">
                <Input />
              </Form.Item>
            </Col>
            <Col span={2}></Col>
            <Col span={6}></Col>
            <Col span={9}></Col>
            <Col span={7}>
              <Form.Item {...tailLayout}>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  htmlType="submit"
                  onClick={() => setLoading(true)}
                  loading={loading}
                >
                  Güncelle
                </Button>
              </Form.Item>
            </Col>
            <Col span={2}></Col>
          </Row>
        </Form>
      </>
    </div>
  );
};
export default InvoiceSubscriptionUpdate;
